module.exports = __webpack_public_path__ + "static/flags/MO-539c4ad76cffd2fb40a8811e68c1cffe.gif";